/// <reference types="react"/>
import { ApexOptions } from "apexcharts";
import React from "react";
import ReactApexChart from "react-apexcharts";

interface ChartProps {
  currentAmount: number;
  remainingAmount: number; 
  height:number;
}

const Chart: React.FC<ChartProps> = ({ currentAmount, remainingAmount, height }) => {
  const usedAmount = currentAmount - remainingAmount;
  
  // Calculate percentages and round to 2 decimal places
  const usedPercentage = ((usedAmount / currentAmount) * 100).toFixed(2);
  const remainingPercentage = ((remainingAmount / currentAmount) * 100).toFixed(2);

  // Convert the series values back to numbers for the chart
  const series = [parseFloat(usedPercentage), parseFloat(remainingPercentage)];

  const options: ApexOptions = {
    chart: {
      type: "donut",
    },
    colors: ["#b91c1c", "#047857"], 
    legend: {
      show: false, 
    },
    dataLabels: {
      style: {
        colors: ['#fff'],
      },
      formatter: function (val: number) {
        return val.toFixed(2) + '%'; 
      }
    },
    labels: ['Used', 'Remaining'], 
  };

  return <ReactApexChart options={options} series={series} type="donut" height={height} />;
};

export default Chart;
